import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                richColors
                toastOptions={{
                    style: {
                        fontFamily: "'Outfit', sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
